<template>
  <div class="">
    <BaseTemp>
      <template v-slot:content>
        <PrivacyPolicy />
      </template>
    </BaseTemp>
  </div>
</template>


<style lang="sass">

</style>

<script>
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import BaseTemp from "@/components/BaseTemp.vue";

export default {
  name: "PrivacyComp",
  components: {BaseTemp,PrivacyPolicy}
};
</script>